export default {
  p1: [
    'To all the aspiring SAS programmers out there, STATECS organizes regular SAS programming trainings delivered by experienced and highly qualified specialists. All the applicants who finish the course successfully, get the opportunity to join STATECS team and invest their knowledge in practice.',
  ],
  imgSrc: '/assets/images/team/trainings_1.png',
  p2: [
    'Wondering why you should take our SAS courses? Here are some of the many reasons why SAS is worth your efforts and time:',
    '●\tCareer opportunities at STATECS',
    '●\tSAS is a fourth-generation language - quite fun to learn with access to multiple applications',
    '●\tHigh versatility when it comes to data analysis',
    '●\tA large network of SAS developers out there. Making connections matters',
    '●\tFun and interactive learning environment',
  ],
  p3: [
    'Don’t miss the opportunity to take the next step in your career and improve your skills forward. STATECS team are looking forward to their future colleagues.',
  ],
};
